<template>
    <div class="layout__position-left layout__width-100">

        <!--todo maybe add pagination to the search but will have to make an additional call for the csv download-->

        <!--{{this.finalQuery}}<br>-->
        <!--&lt;!&ndash;{{this.customers[0]}}&ndash;&gt;-->

        <!--<br>-->
        <!--{{this.searchParams}}<br>-->
        <!--{{this.freetextQueryOptions}}-->

        <el-form :model="searchParams" status-icon :rules="rules" ref="searchParams">

            <div class="layout__padding-clear text__align-center layout__width-100">
                <div class="layout__form__customers">
                    <p class="layout__margin__bottom-10">Search</p>
                    <el-form-item prop="freetext">
                        <el-input placeholder="Search" v-model="searchParams.freetext"
                                  clearable
                                  autofocus></el-input>
                    </el-form-item>
                </div>
                <div class="layout__form__customers">
                    <p class="layout__margin__bottom-10">Status</p>
                    <el-form ref="status">
                        <el-form-item prop="search">
                            <el-select v-model="searchParams.status" placeholder="Order Status" clearable>
                                <el-option v-for="status in ravensworth.activeStatusWithHold.options"
                                           :key="status.id"
                                           :label="status.name"
                                           :value="status.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
            </div>

        </el-form>
        <div class="layout__display-block layout__width-100">
            <el-button class="button-red layout__position-center button__base layout__width-150px" v-on:click="getOrders('searchParams')">Search Product
            </el-button>
        </div>
    </div>

</template>

<script>

    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';

    export default {
        name: "adminCustomerSearch",
        mixins: [axios, dataFormatter, backing],
        props: {
            searchParams: Object,
            prices: Array,
            loading: Boolean,
        },
        data() {
            return {
                disableSearchOptions: false,
                jobStatus: '',
                convertFromDate: '',
                convertToDate: '',
                serviceRouteUrl: `${process.env.VUE_APP_ACCOUNTSAPIHOST}`,
                queryOptions: [],
                freetextQueryOptions: [],
                resourcePath: '/odata/ProductPriceSearch?$filter=',
                queryConcatAnd: '+and+',
                queryConcatOr: '+or+',
                queryPrefix: 'contains(',
                querySuffix: ')',
                finalQuery: '',
                statuses: [
                    {status: 'ANY STATUS'},
                    {status: 'ACTIVE'},
                    {status: 'INVOICED'},
                    {status: 'DRAFT'},
                    {status: 'CREDITED'},
                    {status: 'CANCELLED'},
                    {status: 'ARCHIVE'}
                ],
                territories: [],
                users: [],
                rules: {
                }
            }
        },
        created() {
            this.isUserAuthorised();

            if (window.sessionStorage.getItem('_priceSearch') !== null && typeof window.sessionStorage.getItem('_priceSearch') !== 'undefined') {
                this.$parent.searchParams = JSON.parse(window.sessionStorage.getItem('_priceSearch'))
            } else {
                console.log('not pulling from getItem')
            }

            this.constructQueryString()

            // todo the search works orders pages spec out initial search criteria and pass into here with orders array and the parent gets updated with the results
        },
        beforeUpdate() {
            window.sessionStorage.setItem('_priceSearch', JSON.stringify(this.$parent.searchParams));
        },

        methods: {
            constructQueryString() {

                this.queryOptions = []
                this.freetextQueryOptions = []

                let searchTerms = Object.assign({}, this.$parent.searchParams)

                let baseQueryUri = this.serviceRouteUrl + this.resourcePath

                this.finalQuery = ''
                //
                if (searchTerms.freetext !== '') {

                    this.freetextQueryOptions.push('contains(code, \'' + searchTerms.freetext + '\')')
                    this.freetextQueryOptions.push('contains(sellPrice, \'' + searchTerms.freetext + '\')')
                    this.freetextQueryOptions.push('contains(name, \'' + searchTerms.freetext + '\')')
                    this.freetextQueryOptions.push('contains(press, \'' + searchTerms.freetext + '\')')
                    this.freetextQueryOptions.push('contains(finishing, \'' + searchTerms.freetext + '\')')
                    this.freetextQueryOptions.push('contains(paperWeight, \'' + searchTerms.freetext + '\')')
                    this.freetextQueryOptions.push('contains(style, \'' + searchTerms.freetext + '\')')
                    this.freetextQueryOptions.push('contains(paperType, \'' + searchTerms.freetext + '\')')
                    this.freetextQueryOptions.push('contains(isoSize, \'' + searchTerms.freetext + '\')')

                }

                if (searchTerms.status !== '' && searchTerms.status !== null) {
                    this.queryOptions.push('status+eq+\'' + searchTerms.status + '\'')
                }
                //
                if (searchTerms.freetext !== '') {
                    console.log('not equals null')
                    this.finalQuery = baseQueryUri.concat('(' + this.freetextQueryOptions.join(this.queryConcatOr) + ')', this.queryConcatAnd, this.queryOptions.join(this.queryConcatAnd))
                } else {
                    this.finalQuery = baseQueryUri.concat(this.queryOptions.join(this.queryConcatAnd))
                }

                console.log(this.finalQuery)

                this.$parent.loading = true
                Axios.get(this.finalQuery, this.returnHeaderUsingToken())
                    .then(response => {
                        console.log(response)
                        this.$parent.prices = response.data.value

                        console.log(this.$parent.prices.length)

                        // this.orders
                        // this.jobs = response.data.result.reverse()
                        // //
                        // for (let i = 0; i < this.$parent.customers.length; i++) {
                        //     // this.$parent.customers[i].Ordered = this.$parent.customers[i].Ordered.split("T")[0]
                        //     this.$parent.customers[i].created = this.$parent.customers[i].created.split("T")[0]
                        //     //     // this.jobs[i].despatched = new Date(this.jobs[i].despatched).toLocaleDateString('en-GB')
                        //     //     //     // this.jobs[i].billGrossTotal = this.jobs[i].billGrossTotal.toFixed(2)
                        // }
                        this.$parent.loading = false
                    })
                    .catch(error => {
                        this.$parent.loading = false
                        // if (error.response.status === 500) {
                        this.$parent.prices = []
                        // }
                    })

            },
            getOrders(searchParams) {


                this.$refs[searchParams].validate((valid) => {
                    if (valid) {
                        this.constructQueryString()
                    } else {
                        return false;
                    }
                })
            }
        }
    };
</script>